/**
 * 在新窗口打开链接
 * @param {string} url - 链接地址
 */
export function newPage(url) {
  // 判断是否是本域名的链接
  const isInternalLink = url.startsWith('/');
  // 如果是本域名的链接，拼接完整路径
  const fullUrl = isInternalLink ? window.location.origin + url : url;
  // 在新窗口打开链接
  window.open(fullUrl, '_blank');
}


/**
 * 复制内容到剪贴板
 * @param {string} text - 要复制的内容
 * @returns {Promise<void>}
 */
export function copyToClipboard(text) {
  return new Promise((resolve, reject) => {
    // 检查是否支持 navigator.clipboard API
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        resolve();
      }).catch((err) => {
        reject(err);
      });
    } else {
      // 如果不支持 navigator.clipboard，使用 fallback 方法
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed'; // 防止输入框闪烁
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  });
}